module.exports = __webpack_public_path__ + "static/media/Payslip-Oct2019-CE1117.dc8640ab.pdf";